import { createContext } from "react";
import { IMachineCenterLogsContext } from "./MachineCenterLogsInterfaces";

export const initialState: IMachineCenterLogsContext = {
    triggerMachineCenterLogs: () => {},
};

export const MachineCenterLogsContext = createContext(initialState);
